import { getPhotoUrl } from '@alltrails/shared/utils/requests/photoRequests';
import PhotoSize from '@alltrails/types/PhotoSize';
import { X_AT_KEY } from '@alltrails/core/utils/api';

// returns an array of photos that can be processed by the lightbox
function urlReformatPhotos(photos): { id: number; imgUrl: string }[] {
  let imageHash;

  return photos.map(photo => {
    const { id, photo_hash, photoHash } = photo;
    imageHash = photo_hash || photoHash;

    // TODO: Add support for fallback when direct CDN link doesn't work right https://github.com/alltrails/alltrails/pull/10243
    const url =
      id && imageHash
        ? getPhotoUrl({ id, photoHash: imageHash }, PhotoSize.ExtraLarge, true)
        : `/api/alltrails/photos/${id}/image?size=extra_large&api_key=${X_AT_KEY}`;
    return { id, imgUrl: url };
  });
}

export default urlReformatPhotos;
